import React from 'react'
import { useQuery } from 'react-query'
import { indexBy, pathOr, prop } from 'ramda'
import { ICurrencyCode } from './options.type'

/**
 * ALL幣別代碼列表
 */
export const useAllCurrency = () => {
  const { data, isFetching, refetch } = useQuery<ICurrencyCode[]>(['/options/globalCurrencies'], {
    select: data => pathOr([], ['data'], data),
  })

  const byId = React.useMemo(() => {
    return indexBy(prop('currencyCode'), data || [])
  }, [data])

  return { data, isLoading: isFetching, refetch, byId }
}
